import { PROFILE_LANGUAGES, ProfileLanguage, profileLanguageOfLocale } from 'models/organization-profile';

/** DD-3662: small helpers shared by the clinic and supplier profile tabs. */

export const hasProfileText = (...values: Array<string | null | undefined>): boolean =>
    values.some((value) => Boolean(value?.trim()));

/**
 * The lab's own language — its locale setting, else its country's — the language readers
 * fall back to after their own. The backend uses the same rule.
 */
const COUNTRY_LANGUAGE: Record<string, ProfileLanguage> = {
    SE: 'sv',
    NO: 'no',
    DK: 'da',
    FI: 'fi',
    DE: 'de',
    AT: 'de',
    NL: 'nl',
    PL: 'pl',
};
export const labProfileLanguage = (locale?: string | null, country?: string | null): ProfileLanguage =>
    profileLanguageOfLocale(locale ?? undefined) ?? COUNTRY_LANGUAGE[country ?? ''] ?? 'en';

/** The language an editor opens on: the lab's own if written, else the first written one. */
export const initialProfileLanguage = (
    texts: Array<{ language: ProfileLanguage }>,
    labLanguage: ProfileLanguage,
): ProfileLanguage => {
    if (!texts.length || texts.some((text) => text.language === labLanguage)) return labLanguage;
    const firstWritten = PROFILE_LANGUAGES.find((language) => texts.some((text) => text.language === language.code));
    return firstWritten?.code ?? labLanguage;
};
